import { FeedCashieringUpdate } from '@tradingblock/types';
import Config from '../../config';
import { FeedActions, getFeedActions } from './FeedState';
import _ from 'lodash';
import { NotificationActions } from '../global/actions';
import { AdminCashieringActions } from '../global/actions/admin/AdminCashieringActions';

// CashieringWebSocketService.ts
class CashieringWebSocketService {
  private static instance: CashieringWebSocketService;
  private ws: WebSocket | null = null;

  private constructor() {}

  // Singleton instance access
  public static getInstance(): CashieringWebSocketService {
    if (!CashieringWebSocketService.instance) {
      CashieringWebSocketService.instance = new CashieringWebSocketService();
      console.log('new websocket instance created');
    }
    return CashieringWebSocketService.instance;
  }

  // Initialize WebSocket connection
  public async connect(dispatch: React.Dispatch<FeedActions>, dispatcher: any, globalDispatch: any, apiToken: string) {
    try {
      if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
        this.ws = new WebSocket(Config.cashieringWebsockets + '?token=' + apiToken);

        this.ws.onopen = () => {
          dispatcher.connected();
          getFeedActions(dispatch).setCashieringStatus('open');
          globalDispatch(
            NotificationActions.hide({
              status: 'Error',
              title: 'Cashiering WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'cashiering-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
          globalDispatch(
            NotificationActions.read({
              status: 'Error',
              title: 'Cashiering WebSocket Error',
              message: '',
              global: false,
              time: new Date(),
              key: 'cashiering-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onmessage = (ev: MessageEvent) => {
          const jsonVal = ev.data;
          const objVal: any = JSON.parse(jsonVal);

          const convertedObjVal: FeedCashieringUpdate = {
            accountId: objVal.accountId,
            updateTime: new Date(objVal.updateTime),
            updateType: objVal.type,
            updateTypeId: parseInt(objVal.transferId) || objVal.transferId,
            status: objVal.transferState,
          };

          globalDispatch(
            AdminCashieringActions.setLatestCashieringUpdateDataFromWebsocket({
              latestCashieringUpdateDataFromWebsocket: convertedObjVal,
            })
          );
        };

        this.ws.onclose = (ev: CloseEvent) => {
          if (ev.reason) {
            getFeedActions(dispatch).setCashieringCloseReason(ev.reason);
            console.warn(ev.reason);
          }
          getFeedActions(dispatch).setCashieringStatus('closed');
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Cashiering WebSocket Error',
              message: ev.reason ? ev.reason : 'Cashiering Websocket error',
              global: false,
              time: new Date(),
              key: 'cashiering-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };

        this.ws.onerror = error => {
          dispatcher.errored({ error: error, reason: 'Unable to connect', message: 'Datafeed error' });
          getFeedActions(dispatch).setCashieringStatus('error');
          console.error('Cashiering WebSocket error:', error);
          globalDispatch(
            NotificationActions.add({
              status: 'Error',
              title: 'Cashiering WebSocket Error',
              message: 'Cashiering Websocket error',
              global: false,
              time: new Date(),
              key: 'cashiering-feed-error',
              read: false,
              hide: false,
              viewed: false,
            })
          );
        };
      }
    } catch (createWebsocketError) {
      dispatcher.errored({
        error: createWebsocketError,
        reason: 'Error creating Cashiering websocket',
        message: 'Cashiering Websocket error',
      });
    }
  }
  // Send message to WebSocket
  public sendMessage(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(data);
    } else if (this.ws) {
      console.warn('trying to send message to closed/closing websocket', data);
    }
  }

  public shouldTryReconnect = () => {
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      return true;
    }
    return false;
  };

  // Close WebSocket connection
  public closeConnection() {
    if (this.ws) {
      this.ws.close();
    }
  }
}

export const cashieringWebSocketService = CashieringWebSocketService.getInstance();
